/**
 * @file src/firebase/auth.js
 * @description Firebase Authentication instance and Google OAuth provider setup
 * 
 * Exports configured Firebase Auth and Google OAuth provider for use throughout app.
 * Auth persistence is set to localStorage so sessions survive page refreshes.
 * 
 * Usage:
 *   import { auth, provider } from '../firebase/auth';
 *   import { signInWithPopup } from 'firebase/auth';
 *   
 *   // Google OAuth sign-in
 *   const result = await signInWithPopup(auth, provider);
 * 
 * @exports
 *   - auth: Firebase Auth instance
 *   - provider: GoogleAuthProvider instance
 *   - setPersistence: Firebase function
 *   - browserLocalPersistence: Persistence strategy
 */

// src/firebase/auth.js
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";
import { app } from "./firebaseConfig";

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export { setPersistence, browserLocalPersistence };